import React from "react";
import { RestApiClient } from "../../api/restClient";

export const RestApiClientContext = React.createContext<RestApiClient>(new RestApiClient());
